import * as React from "react";
import { CaseClient, ClientResources, LabClient, SampleClient, SampleReadModel } from "@app/api2/api";
import { BPColumn } from "@common/BPReactTable";
import { insertComponentsIntoText, toDateTime } from "@common/Utils";
import { PageHeader } from "@common/PageHeader";
import { Link } from "react-router-dom";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { BPDataTable3 } from "../Common/DataTable/BPDataTable3";
import { BPContainer } from "@/components/bp/bpcontainer";

interface SampleImportProps {
    labId: number;
    caseId: number;

}

class SampleImportState {
    selectedSamples: SampleReadModel[] = [];
    selectAll: boolean;
    selectAllGlobal: boolean;
    caseName: string = '';
}

export class SampleImport extends React.Component<SampleImportProps, SampleImportState> {
    labClient: LabClient = new LabClient();
    sampleClient = new SampleClient();
    translationsContext: React.Context<ClientResources>;
    caseClient: CaseClient = new CaseClient();

    constructor(props) {
        super(props);
        
        this.state = new SampleImportState();
    }

    async componentDidMount(): Promise<void> {
        var res = await this.caseClient.getCaseBasicInfo(this.props.labId, this.props.caseId)
        this.setState({ ...this.state, caseName: res.name });
    }

    render() {
        const columns: BPColumn<SampleReadModel>[] = [
            {
                id: 'selectChk',
                Header: header => <input key={'selectAll'} type="checkbox"
                    checked={this.state.selectAll}
                    onChange={ev => {
                        if (!ev.target.checked) {
                            this.setState({ selectAll: false, selectedSamples: [] });
                        }
                        else {
                            this.setState({ selectAll: true, selectedSamples: header.rows.map(row => row.original) });
                        }
                    }} />,
                collapsing: true,
                Cell: (cell) => <input key={cell.row.original.id} type="checkbox"
                    checked={this.state.selectedSamples.some(c => c.id == cell.row.original.id)}
                    onChange={ev => {
                        if (!ev.target.checked) {
                            this.setState({ selectedSamples: this.state.selectedSamples.filter(x => x.id != cell.row.original.id) });
                        }
                        else {

                            var indexOf = this.state.selectedSamples.findIndex(x => x.id == cell.row.original.id)
                            if (indexOf == -1)
                                this.setState({ selectedSamples: [...this.state.selectedSamples, cell.row.original] });
                        }
                    }} />,
            },
            {
                Header: window.translation.user.name,
                accessor: 'name',
            },
            {
                Header: window.translation.common.created,
                accessor: 'createdAt',
                Cell: (cell) => <span>{toDateTime(cell.row.original.createdAt)}</span>,
                collapsing: true,
            },

        ];

        return (
            <BPContainer>
                <PageHeader header={insertComponentsIntoText(window.translation.sampleView.importTitle, {
                    '{caseName}': <Link key={'caseLink'} to={buildUrl(AppRoutes.CaseDetails, {
                        caseId: this.props.caseId,
                        labId: this.props.labId
                    })}>{this.state.caseName}</Link>
                })} buttons={[{
                    label: window.translation.common.import, action: async () => {
                        await this.sampleClient.import(this.props.labId, this.props.caseId, { labId: this.props.labId, caseId: this.props.caseId, sampleIds: this.state.selectedSamples.map(m => m.id) })
                        window.location.assign(buildUrl(AppRoutes.CaseDetails, { labId: this.props.labId, caseId: this.props.caseId }))
                    }
                }]} />
                <BPDataTable3
                    storeKey="SampleImport"
                    defaultSortField="name"
                    defaultSortAsc={true}
                    enableSearch={true}
                    dataSource={async (p) => {
                        // let showInactive = p.filters.filter(x => x.id == 'showInactive').map(x => x.value).some(x => true)
                        // let labId = p.filters.filter(x => x.id == 'labList').map(x => x.value).find(x => true)
                        let pageData = await this.labClient.getAllImportableSamples(p.perPage, p.page, p.sortBy, p.sortDirection, p.searchValue, this.props.labId);
                        return pageData;
                    }}
                    columns={columns}
                />
            </BPContainer>


        );
    }
}

